const publicPath = '../brandSelectorImage';

const imageList = [
  {
    src: `${publicPath}/toyota.svg`,
    height: 28,
    width: 43,
    id: 612,
    code: '242',
  },
  {
    src: `${publicPath}/hyundai.svg`,
    height: 36,
    width: 56,
    id: 556,
    code: '106',
  },
  {
    src: `${publicPath}/KIA.svg`,
    height: 46,
    width: 55,
    id: 571,
    code: '129',
  },
  {
    src: `${publicPath}/honda.svg`,
    height: 42,
    width: 64,
    id: 554,
    code: '104',
  },
  {
    src: `${publicPath}/nissan.svg`,
    height: 37,
    width: 57,
    id: 422,
    code: '176',
  },
  {
    src: `${publicPath}/suzuki.svg`,
    height: 39,
    width: 59,
    id: 603,
    code: '232',
  },
  {
    src: `${publicPath}/chevrolet.svg`,
    height: 51,
    width: 79,
    id: 499,
    code: '035',
  },
  {
    src: `${publicPath}/mitsubishi.png`,
    height: 45,
    width: 44,
    id: 415,
    code: '169',
  },
  {
    src: `${publicPath}/ford.svg`,
    height: 47,
    width: 72,
    id: 533,
    code: '069',
  },
  {
    src: `${publicPath}/mazda.svg`,
    height: 42,
    width: 64,
    id: 589,
    code: '154',
  },
];

export default imageList;
